export const DOCUMENT_TYPES = {
    DOCUMENT_DNI: 'DNI',
    DOCUMENT_NIE: 'NIE',
    DOCUMENT_PASSPORT: 'FID',
    DOCUMENT_CC: 'CC',
    DOCUMENT_PP: 'PP',
    DOCUMENT_DN: 'DN',
    DOCUMENT_PN: 'PN',
    DOCUMENT_DA: 'DA',
    DOCUMENT_PA: 'PA',
};

export const FOREIGN_DOCUMENT = 'FOREIGN_DOCUMENT';
export const NATIONAL_DOCUMENT = 'NATIONAL_DOCUMENT';
export const INTERNATIONAL_DOCUMENT = 'INTERNATIONAL_DOCUMENT';
